import * as z from 'zod';
import { GradientZod } from '@/types/GradientType';
import { getBubbleShapeValues } from '@/enum/BubbleShapeEnum';
import { getBubbleModeValues } from '@/enum/BubbleModeEnum';
import { ColorThemeEnum } from '@/enum/ColorThemeEnum';

const BubbleStyleZod = z.object({
  id: z.number(),
  color: z.enum([
    ColorThemeEnum.ORANGE,
    ColorThemeEnum.ORANGE_REVERT,
    ColorThemeEnum.BLUE,
    ColorThemeEnum.BLUE_REVERT,
    ColorThemeEnum.DARKBLUE,
    ColorThemeEnum.DARKBLUE_REVERT,
    ColorThemeEnum.PURPLE,
    ColorThemeEnum.PURPLE_REVERT,
    ColorThemeEnum.GREEN,
    ColorThemeEnum.GREEN_REVERT,
    ColorThemeEnum.WHITE,
  ]),
  theme: GradientZod.nullable(),
  shape: z.enum(getBubbleShapeValues()).nullable(),
  mode: z.enum(getBubbleModeValues()).nullable(),
});

export { BubbleStyleZod };
export type BubbleStyleType = z.infer<typeof BubbleStyleZod>;
